module.exports = __webpack_public_path__ + "static/media/instructivoa6.63817d39.png";